import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/plan/view/license.plan.migration.delete.mutation.gql"
import type {
  PlanMigrationDeleteMutation,
  PlanMigrationDeleteMutationVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.migration.delete.mutation"

type Options = MutationHookOptions<
  PlanMigrationDeleteMutation,
  PlanMigrationDeleteMutationVariables
>

export function usePlanMigrationDeleteMutation(options?: Options) {
  return useMutation<
    PlanMigrationDeleteMutation,
    PlanMigrationDeleteMutationVariables
  >(mutation, options)
}
